import apiCall from '@/lib/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

// Action to get a bag by ID
export const getSearchData = createAsyncThunk<
  AxiosResponse<any>, // Return type is the entire Axios response
  string, // Input type is the bag ID as a string
  { rejectValue: any } // Reject value type
>('ai/search', async (data, { rejectWithValue }) => {
  try {
    const response = await apiCall<any>('POST', `/ai/search-rooms`, data);
    return response;
  } catch (error: any) {
    return rejectWithValue(error !== undefined && error !== null ? error : 'Failed to fetch');
  }
});
